import React, { useEffect } from "react";
import Gdsbanner from "./Gdsbanner";
import Gdsabout from "./Gdsabout";
import Gdsfeatures from "./Gdsfeatures";
import Gdscards from "./Gdscards";
import Webbanner from "./Webbanner";

const Gdspage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Gdsbanner/>
      
      <Gdsabout/>

      <Gdsfeatures/>
      <Gdscards/>
    </div>
  );
};

export default Gdspage;